/**
 * Turn a saved add-on's nested selections into indented cart/summary lines.
 *
 * Nesting is unlimited (a modifier can reveal groups, whose modifiers can reveal
 * more), so this recurses and indents one level per step. Shared by the checkout
 * card and both cart views so all three read the same way.
 *
 * Mutates the two arrays it is given, matching how the callers build their lines.
 *
 * `multiplier` is how many units of the parent pick these follow-ups belong to:
 * the server charges them per unit, so 2 x Tartar Sauce with "Extra Tartar x1"
 * prints and costs 2 extra tartars.
 */
export function pushNestedSelectionLines(childSelections, optionTitles, optionsWithPrices, level = 2, multiplier = 1) {
  (childSelections || []).forEach((cg) => {
    if (cg.modifierGroupName) {
      // The group fee is charged per parent unit too, so scale what prints.
      const groupFee = (parseFloat(cg.groupFee) || 0) * multiplier;
      optionsWithPrices.push({
        title: `${cg.modifierGroupName}:`,
        price: groupFee > 0 ? groupFee.toFixed(2) : '',
        level,
        header: true,
      });
    }
    (cg.selectedModifiers || []).forEach((cm) => {
      const qty = cm.quantity || 1;
      // lineTotal is what the group's rules actually charge — under a "1st FREE"
      // tier the base price is not it. Older saved lines have no lineTotal, so
      // fall back to base * qty.
      const p = (cm.lineTotal != null
        ? (parseFloat(cm.lineTotal) || 0)
        : (parseFloat(cm.price) || 0) * qty) * multiplier;
      const shownQty = qty * multiplier;
      optionTitles.push(cm.modifierName);
      optionsWithPrices.push({
        title: shownQty > 1 ? `• ${cm.modifierName} (x${shownQty})` : `• ${cm.modifierName}`,
        price: p > 0 ? p.toFixed(2) : '',
        level,
      });
      if (cm.childSelections && cm.childSelections.length > 0) {
        pushNestedSelectionLines(cm.childSelections, optionTitles, optionsWithPrices, level + 1, multiplier * qty);
      }
    });
  });
}
